import { render, staticRenderFns } from "./MatterProgram.vue?vue&type=template&id=d57bedee&scoped=true"
import script from "./MatterProgram.vue?vue&type=script&lang=js"
export * from "./MatterProgram.vue?vue&type=script&lang=js"
import style0 from "@/utils/rich_text_editor.css?vue&type=style&index=0&id=d57bedee&prod&scoped=true&lang=css&external"
import style1 from "./MatterProgram.vue?vue&type=style&index=1&id=d57bedee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d57bedee",
  null
  
)

export default component.exports